module.exports = __webpack_public_path__ + "media/images/brand/logo-circular-2026-407748899d469599e2b33eceeb334543.svg";